import { ExternalLink } from 'lucide-react';

const RecentProject = () => {
  const projects = [
    {
      title: 'Scam Detection & Reporting Platform',
      description:
        'A modern web platform that helps users identify, report, and track online scams using AI-powered scam analysis, city-based scam listings, and community reporting features.',
      tech: ['React.Js', 'Stripe', 'Firebase'],
      image: 'https://fiverr-res.cloudinary.com/image/upload/t_collaboration_hd,q_auto,f_auto/v1/secured-attachments/message/delivery_attachments/839fb9cddf9d6b9b88ec4c60dd4262b8-1777211236024/Screenshot%202026-04-26%20191657.png?__cld_token__=exp=1778536004~hmac=a63e1840e4717394a6c719adc8d66afb2ca214eff73ab881fd3399034390c093',
      live: 'https://scammap.app'
    },
    {
      title: 'VicTan Connect – NEMT Trip Coordination Platform',
      description:
        'A lean MVP dispatch platform for non-emergency medical transportation (NEMT), allowing facilities to submit trips, providers to accept rides, and dispatchers to manage transportation requests in real time.',
      tech: ['React.Js + Vite', 'Tailwind CSS', 'Firebase', 'SEO'],
      image: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/project_item/attachment/ffc141b20e5f7182f5eb2612b866fca7-1777787733406/Screenshot%202026-05-03%20112424.png',
      live: 'https://victanconnect.com',
},
    {
      title: 'Sinharaja Riverside – Tourism & Guesthouse Website',
      description:
        'A modern responsive tourism website for Sinharaja Riverside, an eco-friendly riverside guesthouse. Features image galleries, booking sections, SEO optimization, and mobile-friendly design to improve guest engagement.',
      tech: ['React.Js', 'Lucide Icons', 'SEO & Performance Optimized'],
      image: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/project_item/attachment/38948ffe8b727da2375024a355493565-1773491844086/Screenshot%202026-03-14%20180632.png',
      live: 'https://sinharaja-riverside.com',
    },
  ];

  return (
    <section id="projects" className="py-24 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl sm:text-5xl font-light text-white text-center mb-16">
          Recent Projects
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, index) => (
            <div
              key={index}
              className="border border-gray-800 rounded-sm overflow-hidden group hover:border-gray-500 transition-colors duration-300"
            >
              <div className="h-64 bg-gray-900 flex items-center justify-center overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-all duration-500"
                />
              </div>
              <div className="p-6 space-y-4">
                <h3 className="text-lg font-light text-white">
                  {project.title}
                </h3>
                <p className="text-gray-400 text-sm font-light leading-relaxed">
                  {project.description}
                </p>
                <div className="flex flex-wrap gap-2 pt-2">
                  {project.tech.map((tech, techIndex) => (
                    <span
                      key={techIndex}
                      className="border border-gray-700 text-gray-400 px-3 py-1 rounded-sm text-xs font-light"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
                {project.live && (
                  <a
                    href={project.live}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 mt-4 text-white text-sm font-medium hover:text-gray-300 transition-colors duration-300"
                  >
                    View Live <ExternalLink className="w-4 h-4" />
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecentProject;